import { useState } from "react";
import PortalNavbar from "@/components/feature/PortalNavbar";
import PortalFooter from "@/components/feature/PortalFooter";
import BackToTop from "@/components/feature/BackToTop";
import Seo from "@/components/feature/Seo";
import { newsList, categories } from "@/mocks/portal";

const schema = {
  "@context": "https://schema.org",
  "@type": "Blog",
  name: "曝光导航 · 最新爆料",
  description: "曝光导航最新爆料栏目，聚合综艺影视音乐时尚等圈内最新动态与深度解读。",
  inLanguage: "zh-CN",
};

export default function LatestPage() {
  const [active, setActive] = useState("全部");

  const filtered = active === "全部" ? newsList : newsList.filter((n) => n.category === active);

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <Seo
        title="最新爆料 - 曝光导航 · 娱乐新料速递"
        description="曝光导航最新爆料栏目实时聚合综艺、影视、音乐、时尚等圈内最新动态与深度解读，新料速递助你第一时间掌握吃瓜节奏。"
        keywords="最新爆料,娱乐新料,热点资讯,圈内动态,曝光导航"
        schema={schema}
      />
      <PortalNavbar />
      <main className="flex-1">
        <section className="bg-background-100/60">
          <div className="mx-auto max-w-7xl px-4 py-12 md:px-6">
            <nav aria-label="面包屑" className="mb-6 flex items-center gap-1.5 text-xs text-foreground-500">
              <a href="/" className="hover:text-primary-600">首页</a>
              <i className="ri-arrow-right-s-line" />
              <span className="text-foreground-800">最新爆料</span>
            </nav>

            <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
              <div>
                <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-600 px-3 py-1 text-xs font-semibold text-background-50">
                  <i className="ri-bubble-chart-line" />
                  最新爆料
                </span>
                <h1 className="mt-3 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">新料速递 · 深度解读</h1>
                <p className="mt-3 max-w-xl text-sm leading-6 text-foreground-600">
                  聚合各栏目最新动态，用分类筛选快速找到你关心的领域新料。
                </p>
              </div>
            </div>

            {/* 分类筛选 */}
            <div className="mt-6 flex flex-wrap items-center gap-2">
              {categories.map((c) => (
                <button
                  key={c}
                  type="button"
                  onClick={() => setActive(c)}
                  className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-medium transition-colors ${
                    active === c ? "bg-primary-500 text-background-50" : "bg-background-50 text-foreground-700 ring-1 ring-background-200 hover:text-primary-600"
                  }`}
                >
                  {c}
                </button>
              ))}
            </div>

            {/* 内容列表 */}
            <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
              {filtered.map((n) => (
                <article
                  key={n.id}
                  className="group flex flex-col overflow-hidden rounded-xl border border-background-200 bg-background-50 transition-all hover:-translate-y-1 hover:shadow-sm"
                >
                  <a href="/about" className="relative block h-48 overflow-hidden">
                    <img
                      src={n.image}
                      alt={n.title}
                      className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                    />
                    <span className="absolute left-3 top-3 rounded bg-background-50/90 px-2 py-0.5 text-xs font-medium text-primary-600">
                      {n.category}
                    </span>
                    {n.tag && (
                      <span className="absolute right-3 top-3 rounded bg-accent-500 px-2 py-0.5 text-xs font-bold text-background-50">
                        {n.tag}
                      </span>
                    )}
                  </a>
                  <div className="flex flex-1 flex-col p-5">
                    <h2 className="font-heading text-lg font-bold leading-snug text-foreground-950 line-clamp-2">
                      {n.title}
                    </h2>
                    <p className="mt-2 flex-1 text-sm leading-6 text-foreground-600 line-clamp-3">{n.excerpt}</p>
                    <div className="mt-4 flex items-center gap-4 text-xs text-foreground-500">
                      <span className="flex items-center gap-1"><i className="ri-time-line" />{n.time}</span>
                      <span className="flex items-center gap-1"><i className="ri-eye-line" />{n.reads} 阅读</span>
                    </div>
                  </div>
                </article>
              ))}
            </div>
            {filtered.length === 0 && (
              <p className="mt-8 text-center text-sm text-foreground-600">该栏目暂无新料，换个分类看看吧。</p>
            )}
          </div>
        </section>
      </main>
      <PortalFooter />
      <BackToTop />
    </div>
  );
}